/* eslint-disable no-debugger */
import { toast } from 'react-toastify';
import { userService } from '../../service/user.service';
import { alertConstants, Types as userConstants, getConstants } from './actionType';
import 'react-toastify/dist/ReactToastify.css';

function login(email, type) {
    function failure(error) {
        return { type: userConstants.LOGIN_FAILURE, error };
    }
    return async (dispatch) => {
        const data = await userService.login(email, type);
        if (data.error) {
            dispatch(failure(data.message.response.data?.message || data.message || 'Something went wrong' ));
            toast.error(data.message);
            return data;
        }
        toast.success(data.message);
        return data;
    };
}
function VerifyOtp(email, otp, session,type) {
    function request(user) { return { type: userConstants.LOGIN_REQUEST, user }; }
    function success(user) { return { type: userConstants.LOGIN_SUCCESS, user }; }
    function failure(error) {
        return { type: userConstants.LOGIN_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await userService.VerifyOtp(email, otp, session, type);
        if (data.error) {
            dispatch(failure(data.message));
            toast.error('Invalid OTP');
            return data;
        }
        toast.success(data.message);
        dispatch(success(data));
        return data;
    };
}
function resendOtp(email, session, type) {
    function request(user) { return { type: alertConstants.REQUEST, user }; }
    function success(user) { return { type: alertConstants.SUCCESS, user }; }
    function failure(error) {
        return { type: alertConstants.ERROR, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await userService.resendOtp(email, session, type);
        if (data.error) {
            dispatch(failure(data.message));
            toast.error('Something went Wrong');
            return data;
        }
        toast.success(data.data.message);
        dispatch(success(data));
        return data;
    };
}
function logout() {
    userService.logout();
    return { type: userConstants.LOGOUT };
}
function getRoles() {
    function request(user) { return { type: getConstants.GET_ALL_REQUEST, user }; }
    function success(user) {
        return { type: getConstants.GET_ALL_SUCCESS, user };
    }
    function failure(error) {
        return { type: getConstants.GET_ALL_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await userService.getRoles();
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        }
        dispatch(success(data));
        return data;
    };
}
function createUser(body) {
    function request(user) { return { type: alertConstants.REQUEST, user }; }
    function success(user) { return { type: alertConstants.SUCCESS, user }; }
    function failure(error) {
        return { type: alertConstants.ERROR, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await userService.createUser(body);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        }
        toast.success(data.data.message);
        dispatch(success(data));
        return data;
    };
}
function UserList(page, searchValue, filterValue) {
    function request(user) { return { type: getConstants.GET_ALL_USER_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_ALL_USER_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_ALL_USER_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await userService.UsersList(page, searchValue, filterValue);
        if (data.error) {
            dispatch(failure(data.message));
            return data;
        }
        dispatch(success(data));
        return data;
    };
}
function updateAdminUser(body, email) {
    function request(user) { return { type: getConstants.GET_PARTICULAR_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_PARTICULAR_SUCCESS, user }; }
    function failure(error) {
        return { type: getConstants.GET_PARTICULAR_FAILURE, error };
    }
    return async (dispatch) => {
        dispatch(request());
        const data = await userService.updateAdminUser(body, email);
        if (data.error) {
            dispatch(failure(data.message));
        }
        dispatch(success(data));
        return data;
    };
}
function SortUser(body) {
    function request(user) { return { type: getConstants.GET_PARTICULAR_REQUEST, user }; }
    function success(user) { return { type: getConstants.GET_PARTICULAR_SUCCESS, user }; }

    return async (dispatch) => {
        dispatch(request());
        dispatch(success(body));
        return body;
    };
}
function AdminPaginationMethod(data, type) {
    function add(user) { return { type: getConstants.ADD_PAGINATION, user }; }
    function remove(user) { return { type: getConstants.REMOVE_PAGINATION, user }; }

    return async (dispatch) => {
        if (type === 'add') {
            dispatch(add(data));
        } else {
            dispatch(remove(data));
        }
        return data;
    };
}
export const UserActions = {
    login,
    VerifyOtp,
    resendOtp,
    getRoles,
    createUser,
    UserList,
    logout,
    updateAdminUser,
    SortUser,
    AdminPaginationMethod,

};